//Import React Hooks
import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';

// import created components  :

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";

// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

//MUI :
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Alert from '@mui/material/Alert';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import Drawer from '@mui/material/Drawer';
import PanierList from '../../../components/location/panierList/PanierList.jsx';


// API fetch
import axios from "axios";
import { baseURL } from '../../../config/api-config.js';


//Translate utils :
import { translator } from "../../../utils/translator.js"
import parse from 'html-react-parser';

//import { useSelector, useDispatch } from "react-redux";
import { getLang, getLocation, getStepLocation, getPanier } from "../../../store/selectors.js"; //global state : shopping state
import { locationSlice } from '../../../store/locationSlice.js';
import { stepLocationSlice } from '../../../store/stepLocationSlice.js';
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)

//utils
import { getTotalPanier, tarifDecimalConverter } from '../../../utils/calcul-tarif'


//data
//import { dbArticles } from '../../../data/mock.js'

function RecapPanier({ dbArticles, dbTailles }) { // full page as component imported in router

    const dispatch = useDispatch();
    const lang = useSelector(getLang) //global state : shopping step
    const panier = useSelector(getPanier) //global state : shopping step
    const location = useSelector(getLocation) //global state : shopping step
    const locationStep = useSelector(getStepLocation) //global state : shopping step

    const [totalPanier, setTotalPanier] = useState({ total: 0, difference: 0, combos: 0 })

    const [open, setOpen] = useState(false);

    const toggleDrawer = (newOpen) => () => {
        setOpen(newOpen);
    };

    useEffect(() => {

        setTotalPanier(getTotalPanier(dbArticles, panier, location));

    }, [panier, location])

    useEffect(() => {
        setOpen(false);
    }, [locationStep])

    function getArticleQty() {
        let qty = 0
        panier.forEach(article => {
            qty += article.qte;
        })
        return qty;
    }



    return (
        <div className="location-panier-recap">


            <div className="location-panier-recap-infos">
                <div className="location-panier-recap-infos-qte">
                    <p><ShoppingCartIcon /> {getArticleQty()} {translator("articles", lang, "recapPanierArticles")} {totalPanier.combos > 0 ? <span>/ {totalPanier.combos} {translator("kit planche+combi", lang, "recapPanierkit")}</span> : null}</p>
                </div>
                <div className="location-panier-recap-infos-total">
                    <p>{translator("Montant total de votre panier :", lang, "recapPanierMontant")}</p>
                    <h4>{tarifDecimalConverter(totalPanier.total - (totalPanier.difference * totalPanier.combos))}€</h4>
                </div>

            </div>

            <div className="location-panier-recap-bouton">
                <Button
                    variant="contained"
                    disabled={panier.length === 0}
                    onClick={toggleDrawer(true)}
                >{translator("Voir le panier", lang, "recapPanierVoir")}</Button>
            </div>


            <Drawer open={open}
                onClose={toggleDrawer(false)}
                anchor={"bottom"}
            >
                <div className="location-drawer-container">

                    <div className="location-drawer-bt-close">
                        <div className="location-panier-recap-bouton">
                            <Button
                                variant="contained"
                                size="small"
                                onClick={toggleDrawer(false)}
                            >{translator("Fermer", lang, "panierListFermer")}</Button>

                        </div>

                    </div>

                    <PanierList dbArticles={dbArticles} dbTailles={dbTailles} />
                    <div className="location-drawer-bt-next">
                        {locationStep < 2 ?
                            <Button
                                className="bottom-nav-next"
                                onClick={_ => dispatch(stepLocationSlice.actions.nextStep())}
                                variant="contained">
                                {translator("Valider le panier", lang, "panierListValider")}

                            </Button> : null
                        }
                    </div>
                </div>
            </Drawer>

        </div >



    );
}

export default RecapPanier;